import { connect } from 'react-redux';
import AddressSearchLoading from '../../components/AddressSearch/AddressSearchLoading/AddressSearchLoading';
import { HomeSelector } from '../reducers/HomeReducer';

const mapStateToProps = state => ({
  showLoading: HomeSelector.getIsLoading(state)
});

const AddressSearchLoadingContainer = connect(mapStateToProps)(AddressSearchLoading);

export default AddressSearchLoadingContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/AddressSearchLoadingContainer.js
 **/